import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SelectedYearProvider} from '../../control/selected-year-provider';

@Component({
  selector: 'app-year-selector',
  imports: [
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './year-selector.html',
  styleUrl: './year-selector.scss'
})
export class YearSelector implements OnInit {
  protected formGroup!: FormGroup
  protected readonly years: number[] = []

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly selectedYearProvider: SelectedYearProvider,
  ) {
    const fullYear = new Date().getFullYear();
    for (let i = 0; i < 10; i++) {
      this.years.push(fullYear - i)
    }
  }

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      year: this.selectedYearProvider.year
    })
    this.formGroup.valueChanges.subscribe(entireForm => this.changeYear(entireForm.year))
  }

  protected changeYear(year: number) {
    this.selectedYearProvider.setSelectedYear(year)
  }

}
